import {memo} from 'react'
import type {EntryPointProps} from 'react-relay'
import {useLocation} from 'react-router-dom'

import type {BuildId} from '../../../../types'
import {useFetchBuildTestCounters} from '../../../packages/Tests/Tests.hooks'

import type {BuildTestsTabCountsQuery} from './__generated__/BuildTestsTabCountsQuery.graphql'
import {countsQuery, getCountsVariables} from './BuildTestsTab.queries'
import {getFilterQueryParams} from './BuildTestsTab.utils'
import TestScopesView from './TestScopesView/TestScopesView'
import TestsFilter from './TestsFilter/TestsFilter'
import {ViewType} from './TestsFilter/TestsViewSelect/TestsViewSelect.utils'
import TestsView from './TestsView/TestsView'

type Props = {
  buildId: BuildId
  buildLocator?: string
}

type Queries = {counts: BuildTestsTabCountsQuery}

function BuildTestsTab({queries, props}: EntryPointProps<Queries, {}, Props, {}>) {
  const {buildId, buildLocator} = props
  const location = useLocation()
  const {view} = getFilterQueryParams(location)

  const {testOccurrences} = useFetchBuildTestCounters(
    buildId,
    buildLocator,
    countsQuery,
    queries.counts,
    getCountsVariables,
  )

  return (
    <>
      <TestsFilter countsKey={testOccurrences?.testCounters ?? null} />
      {view === ViewType.TESTS ? (
        <TestsView buildId={buildId} />
      ) : (
        <TestScopesView buildId={buildId} countsKey={testOccurrences?.testCounters ?? null} />
      )}
    </>
  )
}

export default memo(BuildTestsTab)
export type BuildTestsTabComponent = typeof BuildTestsTab
